import { useRef, Fragment, useState, useEffect } from 'react';
import { getCaptionValue } from '@pm2/content-engine';
import { breakpoints } from '@ui/css';
import { useMatchBreakpoint, useToggleState, SizeTransition, Chevron } from '@utils/react';
import { spanCls } from '../../atoms/styles/Caption.js';
import { wrapper, description, descriptionTransitionDurationMs, descriptionTogglerWrapper, descriptionToggler } from './atom.description.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const PUNCTUATION_REGEX = /[.,!?]\s*$/;
function Description(props) {
  const descriptionRef = useRef(null);
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const [isDescriptionExpanded, expansionActions] = useToggleState();
  const canExpandDescription = useCanExpand(descriptionRef, {
    enabled: !props.isScrambled
  });
  const captionModel = extractCaptionContent(props.caption);
  const displayDescription = captionModel.description || captionModel.authorOrArtist || captionModel.country || captionModel.duration || captionModel.year || captionModel.copyright;
  if (!displayDescription) {
    return null;
  }
  const description$1 = [captionModel.description && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.description
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.description)
  }, "description"), captionModel.caption && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.caption
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.caption)
  }, "caption"), captionModel.authorOrArtist && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.authorOrArtist
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.authorOrArtist)
  }, "authorOrArtist"), captionModel.country && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.country
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.country)
  }, "country"), captionModel.duration && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.duration
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.duration)
  }, "duration"), captionModel.year && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.year
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.year)
  }, "year"), captionModel.copyright && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: "©&nbsp;" + captionModel.copyright
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.copyright)
  }, "copyright")].filter(it => !!it);
  const hasTitle = !!props.caption.title?.value;
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsx(SizeTransition, {
      timeout: descriptionTransitionDurationMs,
      axis: "vertical",
      in: isDescriptionExpanded,
      classNames: description,
      getMinSizeInPx: () => ({
        height: isMobile ? hasTitle ? 0 : 19 : hasTitle ? 44 : 66
      }),
      nodeRef: descriptionRef,
      children: ref => /*#__PURE__*/jsx("p", {
        ref: ref,
        className: description,
        "data-expanded": isDescriptionExpanded,
        "data-scrambled": props.isScrambled,
        children: description$1.map((it, index) => /*#__PURE__*/jsxs(Fragment, {
          children: [it, /*#__PURE__*/jsx("span", {
            children: index < description$1.length - 1 && (it.props["data-comma"] === true ? ", " : " ")
          })]
        }, index))
      })
    }), /*#__PURE__*/jsx("div", {
      className: descriptionTogglerWrapper,
      children: canExpandDescription && /*#__PURE__*/jsxs("button", {
        onClick: expansionActions.toggle,
        className: descriptionToggler,
        children: [/*#__PURE__*/jsx("span", {
          children: isMobile ? isDescriptionExpanded ? "Skjul beskrivelse" : "Se beskrivelse" : isDescriptionExpanded ? "Se mindre" : "Se mere"
        }), " ", /*#__PURE__*/jsx(Chevron, {
          vertical: true,
          size: 8,
          lineWidth: 1.5,
          inversed: isDescriptionExpanded
        })]
      })
    })]
  });
}
function extractCaptionContent(caption) {
  return Object.fromEntries(Object.entries(caption).map(([key, property]) => [key, getCaptionValue(property, true)]));
}

/**
 * the introduction should become expandable/collapsible in case there exists
 * more than three lines of text or in case any media is included in the
 * introduction.
 */
function useCanExpand(ref, args) {
  const [canExpand, setCanExpand] = useState(args.enabled);
  useEffect(() => {
    if (!args.enabled) {
      setCanExpand(false);
      return;
    }
    const element = ref.current;
    if (!element) {
      return;
    }
    setCanExpand(element.scrollHeight > element.clientHeight);
  }, [args.enabled, ref]);
  return canExpand;
}

export { Description };
//# sourceMappingURL=atom.description.js.map
